<template>
  <WiseForm v-if="organizationDetails.payoutType === 'WISE'" />
  <PayPalVerify v-else-if="organizationDetails.payoutType === 'PAYPAL' || !organizationDetails.payoutType" />
</template>

<script>
import { mapState } from 'vuex'
import PayPalVerify from '@/views/PayPalVerify'
import WiseForm from '@/views/WiseForms'

export default {
  name: 'ReceiveMoney',
  components: {
    PayPalVerify,
    WiseForm
  },
  computed: {
    ...mapState(['user', 'organizationDetails', 'currentRequest']),
  },
}
</script>

<style lang="scss" scoped>
</style>
